@if (label !== null) {
  <div class="token-chip-picker-label">{{ label }}</div>
}
<div class="token-chip-picker-wrap">
  <div class="token-chip-picker-row">
    <div
      class="chip-strip"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
    >
      @if (chips.length === 0) {
        <span class="chip-placeholder">{{ placeholder }}</span>
      }
      @for (chip of chips; track trackChip($index, chip); let chipIndex = $index) {
        @if (isToken(chip) && !isCustomSlot(chip)) {
          <span class="chip" cdkDrag>
            <span class="drag" cdkDragHandle>⋮⋮</span>
            <span class="chip-text">{{ chipLabel(chip) }}</span>
            <span
              class="rm"
              role="button"
              tabindex="0"
              (click)="removeAt(chipIndex)"
              (keydown.enter)="removeAt(chipIndex); $event.preventDefault()"
              [attr.aria-label]="'Remove ' + chipLabel(chip)"
            >✕</span>
          </span>
        } @else if (isCustomSlot(chip)) {
          <span class="chip custom-slot" cdkDrag>
            <span class="drag" cdkDragHandle>⋮⋮</span>
            <span class="chip-text">{{ chipLabel(chip) }}</span>
            <span
              class="rm"
              role="button"
              tabindex="0"
              (click)="removeAt(chipIndex)"
              (keydown.enter)="removeAt(chipIndex); $event.preventDefault()"
              [attr.aria-label]="'Remove ' + chipLabel(chip)"
            >✕</span>
          </span>
        } @else if (isTemplateCustomChip(chip)) {
          <span class="chip template-common-custom" cdkDrag title="Shared across every per-select row">
            <span class="drag" cdkDragHandle>⋮⋮</span>
            <input
              #customInput
              type="text"
              class="template-common-custom-input"
              placeholder="a-z A-Z 0-9 _-."
              [value]="chip.value"
              (keydown)="onCustomKeyDown($event)"
              (input)="updateTemplateCustomChip(chipIndex, $any($event.target).value)"
            />
            <span
              class="rm"
              role="button"
              tabindex="0"
              (click)="removeAt(chipIndex)"
              (keydown.enter)="removeAt(chipIndex); $event.preventDefault()"
              aria-label="Remove custom value"
            >✕</span>
          </span>
        } @else {
          <span class="chip-lit" cdkDrag>
            <span class="drag" cdkDragHandle>⋮⋮</span>
            <span class="chip-text">{{ chipLabel(chip) }}</span>
            <span
              class="rm"
              role="button"
              tabindex="0"
              (click)="removeAt(chipIndex)"
              (keydown.enter)="removeAt(chipIndex); $event.preventDefault()"
              [attr.aria-label]="'Remove ' + chipLabel(chip)"
            >✕</span>
          </span>
        }
      }
    </div>

    <div class="token-chip-picker-outside-actions">
      <button
        mat-icon-button
        type="button"
        class="add-btn"
        #addMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="addMenu"
        aria-label="Add token or separator"
      >
        <mat-icon>add</mat-icon>
      </button>
      @if (showReset) {
        <button
          mat-icon-button
          type="button"
          class="reset-btn"
          (click)="resetCustomValues()"
          aria-label="Reset template custom values"
          matTooltip="Reset custom values"
        >
          <mat-icon>undo</mat-icon>
        </button>
      }
    </div>
  </div>

  <mat-menu #addMenu="matMenu" class="token-chip-picker-menu" xPosition="after">
    <ng-template matMenuContent>
      <div class="menu-body" (click)="$event.stopPropagation()">
        <button
          mat-icon-button
          type="button"
          class="menu-close"
          aria-label="Close"
          (click)="addMenuTrigger.closeMenu()"
        >
          <mat-icon>close</mat-icon>
        </button>

        <p class="menu-head">Insert common template token</p>
        <div class="chip-add-grid">
          @for (item of standardTokens; track item.slug) {
            <span
              class="chip-add-token"
              role="button"
              tabindex="0"
              (click)="addToken(item); $event.stopPropagation()"
              (keydown.enter)="addToken(item); $event.preventDefault()"
            >
              @if (item.slug === 'extension') {
                +<span class="paired-sep">.</span>{{ item.label }}
              } @else {
                + {{ item.label }}
              }
            </span>
          }
          @if (customSlotItems.length > 0) {
            <span
              class="chip-add-template-custom"
              role="button"
              tabindex="0"
              (click)="addTemplateCustomChip(); $event.stopPropagation()"
              (keydown.enter)="addTemplateCustomChip(); $event.preventDefault()"
            >+ custom</span>
          }
          @for (sep of fixedSeparators; track sep) {
            <span
              class="chip-add-sep"
              role="button"
              tabindex="0"
              (click)="addSeparator(sep); $event.stopPropagation()"
              (keydown.enter)="addSeparator(sep); $event.preventDefault()"
            >
              + <span class="sep-glyph">{{ sep }}</span>
            </span>
          }
        </div>
      </div>
    </ng-template>
  </mat-menu>

  @if (hint.length > 0) {
    <div class="chip-hint">{{ hint }}</div>
  }
</div>
